import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import Select from 'react-select'; 
 
const SearchableVehicleSelect = forwardRef((props, ref) => {
     
    const vehicleData = props.vehicleData; 
    const initialValue = props.initialVehicleValue; 
    const orderid=  props.orderId ; 
    const removeidontsee = props.removeidontsee||false;
    const options =  (vehicleData || []).map(vehicleData => ({ 
        value: vehicleData.id, 
        label: vehicleData.name
    })); 

    if (removeidontsee){  
        for (let i = 0; i < options.length; i++) {
            if (options[i].value === '-1') { 
                options.splice(i, 1);  
                i--; 
            }
        }
    }
         
    
    const [selectedOption, setSelectedOption] = useState(null);
    const [finalValue, setFinalValue] = useState(initialValue);
     
    useEffect(() => {  
        if (initialValue && options.length > 0) {
            const initialOption = options.find(opt => parseInt(opt.value) === parseInt(initialValue)); 
            setSelectedOption(initialOption || null);
        }
    }, [initialValue, options.length]); 
     
    useImperativeHandle(ref, () => {
        return {
            getValue() {  
                return finalValue; 
            },
            isPopup() {
                return true; 
            },
        };
    });
 
    const handleChange = (selected) => { 
        
        const newValue = selected ? selected.value : null;
        const oldValue = props.value;
        setSelectedOption(selected); 
        setFinalValue(newValue); 
       
        props.apifunction(orderid,oldValue, newValue);
        
    };
     
    return (
        <Select 
            options={options} 
            value={selectedOption} 
            onChange={handleChange} 
            isSearchable={true}
            placeholder="Vehicle.."  
            menuPortalTarget={document.body}
             
            styles={{ 
                menu: base => ({ ...base, marginTop: '1px' }),
                menuPortal: base => ({ ...base, zIndex: 9999 }),  
                container: base => ({ 
                    ...base, 
                    width:   '180px', 
                    height:   '36px',
                }), 
                control: base => ({
                    ...base,
                    minHeight: '36px', height: '36px', borderRadius: '4px', 
                }),
                indicatorsContainer: base => ({ ...base, height: '36px' }),
            }} 
        />
    );
});

export default SearchableVehicleSelect;